import ajax from '@/utils/ajax'
export default {
  // 查询信用报告
  searchCreditReport(data) {
    return ajax({
      url: 'gt6/public/searchCreditReport',
      method: 'POST',
      data
    })
  },
  // 查询信用报告详情
  searchCreditDetail(params) {
    return ajax({
      url: 'gt6/public/searchDetail',
      method: 'GET',
      params
    })
  },
  // 查询信用报告购买状态
  searchCreditBuyStatus(params) {
    return ajax({
      url: 'gt6/public/searchBuyStatus',
      method: 'GET',
      params
    })
  },
  // 购买信用报告
  buyerCreditReport(data) {
    return ajax({
      url: 'gt6/public/buyerCreditReport',
      method: 'POST',
      data
    })
  },
  // 查询已购买信用报告
  searchBuyCreditReport(data) {
    return ajax({
      url: 'gt6/public/searchBuyCreditReport',
      method: 'POST',
      data
    })
  },
  // 查询已购买信用报告
  getCreditReportData(params) {
    return ajax({
      url: 'gt6/public/getCreditReportData',
      method: 'Get',
      params
    })
  },
  // 导出信用报告
  downloadCreditReport(params) {
    return ajax({
      url: 'gt6/public/downloadCreditReport',
      method: 'Get',
      responseType: 'blob',
      params
    })
  },
  // 获取国家
  getCreditReportCountryOptions() {
    return ajax({
      url: 'gt6/public/getCreditReportCountryOptions',
      method: 'GET',
    })
  },
}